"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggleLink = exports.useEditorToolbar = exports.sortIconKeys = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var slate_1 = require("slate");
var slate_history_1 = require("slate-history");
var icons_1 = __importDefault(require("../../../../assets/icons"));
var objectUtilities_1 = require("../../../../util/objectUtilities");
var Editor_logic_1 = require("../Editor.logic");
var Editor_static_1 = require("../Editor.static");
var EditorToolbar_static_1 = require("./EditorToolbar.static");
var EditorToolbar_style_1 = __importDefault(require("./EditorToolbar.style"));
function sortIconKeys(input, orders) {
    return (0, lodash_1.sortBy)((0, objectUtilities_1.keys)(input), function (key) { return orders[key]; });
}
exports.sortIconKeys = sortIconKeys;
function useEditorToolbar() {
    var _a;
    var _b = __read((0, react_1.useState)(false), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), anchorElement = _c[0], setAnchorElement = _c[1];
    var _d = useUndoRedo(), redo = _d.redo, undo = _d.undo;
    var getIsMarkActive = useGetIsMarkActive();
    var toggleMark = useToggleMark();
    var getIsBlockActive = useGetIsBlockActive();
    var toggleBlock = useToggleBlock();
    var toggleLink = useToggleLink();
    var toolbarMarkIcons = sortIconKeys(EditorToolbar_static_1.markIcons, EditorToolbar_static_1.markIconOrders).map(function (mark) { return ({
        key: mark,
        isActive: getIsMarkActive(mark),
        onMouseDown: function () { return toggleMark(mark); },
        icon: EditorToolbar_static_1.markIcons[mark].path,
        tooltip: EditorToolbar_static_1.markIcons[mark].tooltip,
    }); });
    var toolbarBlockIcons = sortIconKeys(EditorToolbar_static_1.blockIcons, EditorToolbar_static_1.blockIconOrders).map(function (block) { return ({
        key: block,
        isActive: getIsBlockActive(block),
        onMouseDown: function () { return toggleBlock(block); },
        icon: EditorToolbar_static_1.blockIcons[block].path,
        tooltip: EditorToolbar_static_1.blockIcons[block].tooltip,
    }); });
    var toolbarOtherIcons = sortIconKeys(EditorToolbar_static_1.otherIcons, EditorToolbar_static_1.otherIconOrders).map(function (environment) { return ({
        key: environment,
        isActive: getIsBlockActive(environment),
        onMouseDown: toggleLink,
        icon: EditorToolbar_static_1.otherIcons[environment].path,
        tooltip: EditorToolbar_static_1.otherIcons[environment].tooltip,
    }); });
    var toolbarActionIcons = [
        {
            key: Editor_static_1.ActionType.Undo,
            isActive: false,
            onMouseDown: undo,
            icon: icons_1.default.undo,
            tooltip: EditorToolbar_static_1.localText.tooltipUndo,
        },
        {
            key: Editor_static_1.ActionType.Redo,
            isActive: false,
            onMouseDown: redo,
            icon: icons_1.default.redo,
            tooltip: EditorToolbar_static_1.localText.tooltipRedo,
        },
    ];
    var isHeadlineActive = getIsBlockActive(Editor_static_1.ElementType.Headline) || getIsBlockActive(Editor_static_1.ElementType.SubHeadline);
    var styleMenuOptions = [
        {
            isActive: !isHeadlineActive || getIsBlockActive(Editor_static_1.ElementType.Paragraph),
            onClick: function () { return selectStyle(Editor_static_1.ElementType.Paragraph); },
            text: 'Normal text',
            key: 'normal text',
            variant: 'body',
        },
        {
            isActive: getIsBlockActive(Editor_static_1.ElementType.Headline),
            onClick: function () { return selectStyle(Editor_static_1.ElementType.Headline); },
            text: 'Heading',
            key: 'heading',
            variant: 'body2',
        },
        {
            isActive: getIsBlockActive(Editor_static_1.ElementType.SubHeadline),
            onClick: function () { return selectStyle(Editor_static_1.ElementType.SubHeadline); },
            text: 'Subheading',
            key: 'sub heading',
            variant: 'body',
            bold: true,
        },
    ];
    var styleButtonMenuText = ((_a = styleMenuOptions.find(function (item) { return item.isActive; })) === null || _a === void 0 ? void 0 : _a.text) || 'Normal Text';
    var openStyleMenu = function (event) {
        event.preventDefault();
        setAnchorElement(event.currentTarget);
        setIsExpanded(true);
    };
    var closeStyleMenu = function () {
        setAnchorElement(null);
        setIsExpanded(false);
    };
    var selectStyle = function (block) {
        toggleBlock(block);
        closeStyleMenu();
    };
    (0, Editor_logic_1.useEditorHotkeys)({
        'mod+b': function () { return toggleMark(Editor_static_1.MarkType.Bold); },
        'mod+i': function () { return toggleMark(Editor_static_1.MarkType.Italic); },
        'mod+shift+s': function () { return toggleMark(Editor_static_1.MarkType.StrikeThrough); },
        'mod+u': function () { return toggleMark(Editor_static_1.MarkType.Underline); },
        'mod+shift+7': function () { return toggleBlock(Editor_static_1.ElementType.NumberedList); },
        'mod+shift+8': function () { return toggleBlock(Editor_static_1.ElementType.BulletedList); },
        'mod+y': redo,
        'mod+k': toggleLink,
    });
    return {
        anchorElement: anchorElement,
        classes: (0, EditorToolbar_style_1.default)(),
        closeStyleMenu: closeStyleMenu,
        isExpanded: isExpanded,
        openStyleMenu: openStyleMenu,
        styleButtonMenuText: styleButtonMenuText,
        styleMenuOptions: styleMenuOptions,
        toolbarActionIcons: toolbarActionIcons,
        toolbarBlockIcons: toolbarBlockIcons,
        toolbarOtherIcons: toolbarOtherIcons,
        toolbarMarkIcons: toolbarMarkIcons,
    };
}
exports.useEditorToolbar = useEditorToolbar;
function useUndoRedo() {
    var editor = (0, Editor_logic_1.useJackedEditor)();
    return {
        undo: function () { return slate_history_1.HistoryEditor.undo(editor); },
        redo: function () { return slate_history_1.HistoryEditor.redo(editor); },
    };
}
function useGetIsMarkActive() {
    var editor = (0, Editor_logic_1.useJackedEditor)();
    return function (mark) {
        var marks = Editor_static_1.Editor.marks(editor);
        return !!(marks === null || marks === void 0 ? void 0 : marks[mark]);
    };
}
function useToggleMark() {
    var editor = (0, Editor_logic_1.useJackedEditor)();
    var getIsMarkActive = useGetIsMarkActive();
    return function (mark) {
        return getIsMarkActive(mark) ? Editor_static_1.Editor.removeMark(editor, mark) : Editor_static_1.Editor.addMark(editor, mark, true);
    };
}
function useGetIsBlockActive() {
    var editor = (0, Editor_logic_1.useJackedEditor)();
    return function (block) { return !!(0, Editor_logic_1.getSelectionBlockMatch)(editor, block); };
}
function useToggleLink() {
    var editor = (0, Editor_logic_1.useJackedEditor)();
    var selection = editor.selection;
    var getIsBlockActive = useGetIsBlockActive();
    return function () {
        if (getIsBlockActive(Editor_static_1.ElementType.Link)) {
            (0, Editor_logic_1.toggleOffBlock)({ editor: editor, block: Editor_static_1.ElementType.Link });
            return;
        }
        if (!selection) {
            return;
        }
        // Will replace prompt by proper input dialog in CDHX-14855
        // eslint-disable-next-line no-alert
        var urlRaw = prompt(EditorToolbar_static_1.localText.enterLink, 'https://');
        if (!urlRaw) {
            return;
        }
        var url = urlRaw.startsWith('https://') || urlRaw.startsWith('http://') || urlRaw.startsWith('mailto:')
            ? urlRaw
            : "https://".concat(urlRaw);
        var isCollapsed = slate_1.Range.isCollapsed(selection);
        var link = {
            type: Editor_static_1.ElementType.Link,
            url: url,
            children: isCollapsed ? [{ text: url }] : [],
        };
        if (isCollapsed) {
            slate_1.Transforms.insertNodes(editor, link);
        }
        else {
            slate_1.Transforms.wrapNodes(editor, link, { split: true });
            slate_1.Transforms.collapse(editor, { edge: 'end' });
        }
        slate_1.Transforms.move(editor, {
            distance: 1,
            unit: 'offset',
        });
    };
}
exports.useToggleLink = useToggleLink;
function useToggleBlock() {
    var editor = (0, Editor_logic_1.useJackedEditor)();
    var getIsBlockActive = useGetIsBlockActive();
    return function (block) {
        var isBlockActive = getIsBlockActive(block);
        var listTypes = [Editor_static_1.ElementType.NumberedList, Editor_static_1.ElementType.BulletedList];
        var isList = listTypes.includes(block);
        (0, Editor_logic_1.toggleOffBlock)({ editor: editor, block: block, splitNode: true });
        var newType = (function () {
            if (isBlockActive) {
                return Editor_static_1.ElementType.Paragraph;
            }
            return isList ? Editor_static_1.ElementType.ListItem : block;
        })();
        slate_1.Transforms.setNodes(editor, { type: newType });
        if (!isBlockActive && isList) {
            var blockNode = { type: block, children: [] };
            slate_1.Transforms.wrapNodes(editor, blockNode);
        }
    };
}
